var exports = {
  "v": "xe533113f--297490--factoids-list",
};

module.exports = exports;
